import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import ChoosePage from '../views/ChoosePage.vue'
import StudentPage from '../views/StudentPage.vue'
import Notification from '../views/Notification.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		name: 'login',
		component: LoginView
	},
	{
		path: '/',
		name: 'choose-page',
		component: ChoosePage
	},
	{
		path: '/student-page',
		name: 'student-page',
		component: StudentPage
	},
	{
		path: '/notification',
		name: 'notification',
		component: Notification
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
// for save path when close app
// router.afterEach((to, from) => {
// 	if (to.name !== 'login') {
// 		localStorage.setItem('lastRoute', to.path)
// 	}
// })

export default router
